export default __webpack_public_path__ + "static/media/avatar_whitney6.415332b7.mp3";